/**
 * KOVA B3 — max one oversized freight line-item quantity total per order.
 * Uses window.KOVA_OVERSIZED_VARIANT_IDS (from snippet).
 * Soft storefront enforce; shipping weight bands protect margin if bypassed.
 */
(function () {
  var MSG =
    'Only one oversized / freight item can be purchased per order. Remove the other oversized item to continue.';

  function idSet() {
    return window.KOVA_OVERSIZED_VARIANT_IDS || new Set();
  }

  function isOversizedVariantId(id) {
    if (id == null) return false;
    var s = String(id);
    var set = idSet();
    return set.has(s) || set.has(s.replace(/\D/g, ''));
  }

  function countOversized(items) {
    var n = 0;
    (items || []).forEach(function (line) {
      if (isOversizedVariantId(line.variant_id) || isOversizedVariantId(line.id)) {
        n += line.quantity || 1;
      }
    });
    return n;
  }

  function showBanner(root, text) {
    if (!root) return;
    var el = root.querySelector('[data-kova-oversized-banner]');
    if (!el) {
      el = document.createElement('div');
      el.setAttribute('data-kova-oversized-banner', '1');
      el.setAttribute('role', 'alert');
      el.style.cssText =
        'background:#1a1a1a;color:#fff;padding:12px 14px;margin:0 0 12px;font-size:14px;line-height:1.4;';
      root.insertBefore(el, root.firstChild);
    }
    el.textContent = text || '';
    el.style.display = text ? 'block' : 'none';
  }

  function setCheckoutEnabled(form, enabled) {
    if (!form) return;
    form.querySelectorAll('[name="checkout"], .cart__checkout').forEach(function (btn) {
      btn.disabled = !enabled;
      btn.setAttribute('aria-disabled', enabled ? 'false' : 'true');
    });
    form.querySelectorAll('.additional-checkout-buttons').forEach(function (wrap) {
      wrap.style.display = enabled ? '' : 'none';
    });
  }

  function applyCartState(cart) {
    var blocked = countOversized((cart && cart.items) || []) > 1;
    [
      document.getElementById('CartPageForm'),
      document.getElementById('CartDrawerForm'),
    ].forEach(function (form) {
      if (!form) return;
      var root =
        form.querySelector('.drawer__footer') ||
        form.querySelector('.cart__checkout-wrapper') ||
        form.querySelector('[data-products]') ||
        form;
      showBanner(root, blocked ? MSG : '');
      setCheckoutEnabled(form, !blocked);
    });
    return blocked;
  }

  function fetchCart(cb) {
    var url = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) {
        return r.json();
      })
      .then(cb)
      .catch(function () {});
  }

  function parseVariantIdFromBody(body) {
    if (!body) return null;
    if (typeof body === 'string') {
      var m = body.match(/(?:^|&)id=(\d+)/) || body.match(/"id"\s*:\s*"?(\d+)/);
      return m ? m[1] : null;
    }
    if (typeof FormData !== 'undefined' && body instanceof FormData) {
      return body.get('id') || body.get('items[0]id') || null;
    }
    return null;
  }

  var pageVariantOversized = !!(
    document.querySelector('[data-kova-oversized-one-per-order="true"]') ||
    document.querySelector('meta[name="kova-oversized-one-per-order"][content="1"]')
  );

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (!/\/cart\/add/i.test(String(url))) {
        return origFetch.apply(this, arguments);
      }
      var args = arguments;
      var self = this;
      return new Promise(function (resolve, reject) {
        fetchCart(function (cart) {
          var already = countOversized(cart.items || []);
          var addId = parseVariantIdFromBody(init && init.body);
          var adding =
            pageVariantOversized ||
            isOversizedVariantId(addId) ||
            (document.querySelector('form[action*="/cart/add"] [name="id"]') &&
              isOversizedVariantId(
                document.querySelector('form[action*="/cart/add"] [name="id"]').value
              ));
          if (adding && already >= 1) {
            alert(MSG);
            resolve(
              new Response(JSON.stringify({ description: MSG, message: MSG, status: 422 }), {
                status: 422,
                headers: { 'Content-Type': 'application/json' },
              })
            );
            return;
          }
          origFetch
            .apply(self, args)
            .then(function (res) {
              setTimeout(function () {
                fetchCart(applyCartState);
              }, 250);
              resolve(res);
            })
            .catch(reject);
        });
      });
    };
  }

  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || (form.id !== 'CartPageForm' && form.id !== 'CartDrawerForm')) return;
      var submitter = e.submitter;
      var isCheckout =
        !submitter ||
        submitter.name === 'checkout' ||
        (submitter.classList && submitter.classList.contains('cart__checkout'));
      if (!isCheckout) return;
      // sync DOM count
      var qty = 0;
      form.querySelectorAll('[data-kova-oversized-line="true"]').forEach(function (node) {
        var input = node.querySelector('input[name^="updates"], input.cart__qty, input[type="number"]');
        qty += input ? parseInt(input.value, 10) || 1 : 1;
      });
      if (qty > 1) {
        e.preventDefault();
        e.stopPropagation();
        alert(MSG);
      }
    },
    true
  );

  function guardAcceleratedCheckout(cart) {
    // On oversized PDPs: if cart already has oversized, hide Shop Pay / Buy Now
    // so express checkout cannot stack a second freight SKU. Shipping profiles
    // still charge correctly for single-item Shop Pay and for qty bands.
    var already = countOversized((cart && cart.items) || []);
    var onOversizedPdp = pageVariantOversized;
    var hide = onOversizedPdp && already >= 1;
    document.querySelectorAll(
      'shopify-accelerated-checkout, .shopify-payment-button, .additional-checkout-buttons'
    ).forEach(function (el) {
      el.style.display = hide ? 'none' : '';
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    fetchCart(function (cart) {
      applyCartState(cart);
      guardAcceleratedCheckout(cart);
    });
  });
  document.addEventListener('cart:updated', function () {
    fetchCart(function (cart) {
      applyCartState(cart);
      guardAcceleratedCheckout(cart);
    });
  });
})();
